module.exports = __webpack_public_path__ + "static/media/ovestdesktop.611df046.svg";